// Markets V2 used for list of markets not using Backbone
// Calling it v2 because markets is used for backbone markets/outcomes
// That are adapted before being added to Redux state, etc.
// This bundle will include fetching + rendering of markets
// Way simpler, without period/period sets logic that is only used by sports
// that soon will be migrated to the new navigation
import MarketsContainer from './markets_container';

export default MarketsContainer;
